'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { getDayList } from '@mui/x-scheduler-headless/get-day-list';
import { useExtractEventCalendarParameters } from '@mui/x-scheduler-headless/use-event-calendar';
import { schedulerOtherSelectors } from '@mui/x-scheduler-headless/scheduler-selectors';
import { eventCalendarPreferenceSelectors } from '@mui/x-scheduler-headless/event-calendar-selectors';
import { useEventCalendarView } from '@mui/x-scheduler-headless/use-event-calendar-view';
import { createSelectorMemoized } from '@base-ui/utils/store';
import { EventCalendarProvider } from "../internals/components/EventCalendarProvider.mjs";
import { DayTimeGrid } from "../internals/components/day-time-grid/DayTimeGrid.mjs";
import { EventDialogProvider } from "../internals/components/event-dialog/index.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
const WEEK_VIEW_CONFIG = {
  siblingVisibleDateGetter: ({
    state,
    delta
  }) => state.adapter.addWeeks(state.adapter.startOfWeek(schedulerOtherSelectors.visibleDate(state)), delta),
  visibleDaysSelector: createSelectorMemoized(state => state.adapter, schedulerOtherSelectors.visibleDate, eventCalendarPreferenceSelectors.showWeekends, (adapter, visibleDate, showWeekends) => getDayList({
    adapter,
    start: adapter.startOfWeek(visibleDate),
    end: adapter.endOfWeek(visibleDate),
    excludeWeekends: !showWeekends
  }))
};

/**
 * A Week View to use inside the Event Calendar.
 */
export const WeekView = /*#__PURE__*/React.memo(/*#__PURE__*/React.forwardRef(function WeekView(props, forwardedRef) {
  // Feature hooks
  const {
    days
  } = useEventCalendarView(WEEK_VIEW_CONFIG);
  return /*#__PURE__*/_jsx(DayTimeGrid, _extends({
    ref: forwardedRef,
    days: days
  }, props));
}));

/**
 * A Week View that can be used outside of the Event Calendar.
 */
if (process.env.NODE_ENV !== "production") WeekView.displayName = "WeekView";
export const StandaloneWeekView = /*#__PURE__*/React.forwardRef(function StandaloneWeekView(props, forwardedRef) {
  const {
    parameters,
    forwardedProps
  } = useExtractEventCalendarParameters(props);
  return /*#__PURE__*/_jsx(EventCalendarProvider, _extends({}, parameters, {
    children: /*#__PURE__*/_jsx(EventDialogProvider, {
      children: /*#__PURE__*/_jsx(WeekView, _extends({
        ref: forwardedRef
      }, forwardedProps))
    })
  }));
});
if (process.env.NODE_ENV !== "production") StandaloneWeekView.displayName = "StandaloneWeekView";